import { createServerFn } from "@tanstack/react-start";

/**
 * Resolves any hashtag spelling — alias or merged duplicate — to its canonical
 * slug on the server, so /tag/$slug can redirect before anything renders and
 * duplicate hashtag URLs never exist.
 *
 * The lookup runs entirely server-side: no signed-out database role can reach
 * the hashtag registry, and only the canonical address is ever returned.
 */
export const resolveCanonicalTagSlug = createServerFn({ method: "GET" })
  .inputValidator((input: { slug: string }) => ({ slug: String(input.slug ?? "").slice(0, 80) }))
  .handler(async ({ data }) => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");

    const { data: slug, error } = await supabaseAdmin.rpc("canonical_tag_slug", {
      _slug: data.slug,
    });
    if (error) return { slug: null as string | null, found: false };
    return { slug: (slug as string | null) ?? null, found: Boolean(slug) };
  });
